import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {Provider} from 'react-redux';
import Amplify from 'aws-amplify';
import aws_exports from './configuration/aws-exports';
import App from './App';
import './index.css';

Amplify.configure(aws_exports);

ReactDOM.render(
    <Router>
        <App/>
    </Router>,
    document.getElementById('root')
)
;



// WEBPACK FOOTER //
// ./src/index.js